import { SelectList } from '@acies/core';
import ImportComponentCO2LinkListItemRenderer from './import-component-co2link-list-item-renderer';

export class ImportComponentCO2LinkList extends SelectList<string> {
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.paddingHorizontal = 0;
		this.paddingVertical = 0;
		this.gapVertical = 0;
		this.ItemRenderer = ImportComponentCO2LinkListItemRenderer;
	}
}

customElements.define('ac-import-component-co2link-list', ImportComponentCO2LinkList);
